import { Align, Justify, vbml } from '@vestaboard/vbml'

import { IHeader } from '../types'

const noteAlign = (align: Align) => (align === Align.justified ? Align.center : align)

export const formatQAMessage = (message: string | number[][], header?: IHeader, isNote?: boolean) => {
  // Attempt to parse message as JSON array if it's a string
  try {
    if (typeof message === 'string' && message.includes('[')) {
      const json = JSON.parse(message)
      if (Array.isArray(json)) {
        return json
      }
    }
  } catch {}

  if (!header?.isEnabled) {
    const baseAlign = header?.align || Align.center
    return vbml.parse({
      style: {
        width: isNote ? 15 : 22,
        height: isNote ? 3 : 6
      },
      components: [
        {
          style: {
            height: isNote ? 3 : 6,
            width: isNote ? 15 : 22,
            align: isNote ? noteAlign(baseAlign) : baseAlign,
            justify: header?.justify || (isNote ? Justify.center : Justify.justified)
          },
          template:
            typeof message === 'string'
              ? `${message}`
              : vbml.characterCodesToString([...message], {
                  allowLineBreaks: true
                })
        }
      ]
    })
  }

  return vbml.parse({
    style: {
      width: isNote ? 15 : 22,
      height: isNote ? 3 : 6
    },
    components: [
      {
        style: {
          width: isNote ? 1 : 2,
          height: 1
        },
        template: `{${header?.color || '0'}}{${header?.color || '0'}}`
      },
      {
        style: {
          justify: Justify.center,
          align: Align.center,
          width: isNote ? 13 : 18,
          height: 1
        },
        template: header?.text || ''
      },
      {
        style: {
          width: isNote ? 1 : 2,
          height: 1
        },
        template: `{${header?.color || '0'}}{${header?.color || '0'}}`
      },
      {
        style: {
          height: isNote ? 2 : 5,
          width: isNote ? 15 : 22,
          align: isNote ? noteAlign(header?.align || Align.justified) : (header?.align || Align.justified),
          justify: header?.justify || (isNote ? Justify.center : Justify.justified)
        },
        template:
          typeof message === 'string'
            ? `${message}`
            : vbml.characterCodesToString([...message], {
                allowLineBreaks: true
              })
      }
    ]
  })
}
